// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"FinancePriceForm__wrapper__3uUH8","submitResult":"FinancePriceForm__submitResult__28Ve0","actionWrapper":"FinancePriceForm__actionWrapper__1JLvu","wrapper2faOptions":"FinancePriceForm__wrapper2faOptions__20aM-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FinancePriceForm/FinancePriceForm.css
// module id = 2971
// module chunks = 0